import { environment } from './../../../../environments/environment'
import {
  SetDefaultData,
  FetchTemplateRequest,
  UpdateField,
  UpdateTemplateRequest,
  DownloadTemplateRequest,
} from '../templates.actions'
import { getUpdateTemplateState } from '../templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnDestroy, OnInit } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import jsonToFormData from 'json-form-data'
import { FetchTemplateTypesRequest } from '@shared/shared.actions'
import { getTemplateTypesState } from '@shared/shared.select'

@Component({
  selector: 'app-update-template',
  templateUrl: './update-template.component.html',
  styleUrls: ['./update-template.component.css'],
})
export class UpdateTemplateComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public userId: number
  public env = environment
  public templateTypes$: Subscription
  public templateTypes = []
  public templateTypesTranslateKeys = []
  public templateTypesTranslateDefaults = {}

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateTemplate'))
    this.state$ = this.store
      .pipe(select(getUpdateTemplateState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.templateTypes$ = this.store
      .pipe(select(getTemplateTypesState))
      .subscribe((state) => {
        this.templateTypes = state.toJS()
        this.templateTypesTranslateKeys = this.templateTypes.map(
          (template) => template.translationKey,
        )
        this.templateTypesTranslateDefaults = this.templateTypes.reduce(
          (prev, current) => {
            return { ...prev, [current.translationKey]: current.title }
          },
          {},
        )
      })

    this.store.dispatch<any>(new FetchTemplateRequest(this.userId))
    this.store.dispatch<any>(new FetchTemplateTypesRequest())
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    if (e?.target?.name === 'file') {
      this.store.dispatch(
        new UpdateField(
          e.target.name,
          e.target.files[0],
          'updateTemplate.data',
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'updateTemplate.data',
        ),
      )
    }

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateTemplate',
      ),
    )
  }

  public download() {
    this.store.dispatch(new DownloadTemplateRequest(this.state.get('data')))
  }

  private validation() {
    const data = this.state.get('data')
    const rules: any = {
      name: 'required',
    }

    if (this.templateTypes.length) {
      rules.type = 'required'
    }

    const validator = new Validator(
      {
        name: data.get('name'),
        type: data.get('type'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateTemplateRequest(
          this.userId,
          jsonToFormData({ ...payload, type: payload.type?.name }),
        ),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateTemplate',
        ),
      )
    }
  }

  ngOnDestroy(): void {
    this.templateTypes$.unsubscribe()
    this.state$.unsubscribe()
  }
}
